export const INST = process.env.REACT_APP_INST;

export const UNITS = "unit";
export const REVIEWS = "review";
export const GATE_USER = "gate.user";
export const MEETINGS = "meeting";
export const MEETING_USER = "meetingUser";
export const MEETING_VIDEO = "meetingVideo";
export const GENERAL = "rfGeneral";
export const SUBJECT = "rfSubject";
export const USER_ROLE = "gate.userRole";
export const DECISION = "decision";
export const DECISION_FILE = "decisionFile";
export const DECISION_FILE_YK = "decisionFileYk";
export const VOTE = "vote";
export const STATUS_REVIEW = "statusReview";
export const PERIODIC_REPORT = "periodicReports";
export const SUGGESTION = "suggestion";
export const CRON_DATA = "cronData";
export const ANNOUNCEMENT = "announcement";
export const AGENDA_TEMPLATE = "agendaTemplate";